module.exports = /******/
function(modules) {
    /******/
    /******/
    // The require function
    /******/
    function __webpack_require__(moduleId) {
        /******/
        /******/
        // Check if module is in cache
        /******/
        if (installedModules[moduleId]) /******/
        return installedModules[moduleId].exports;
        /******/
        /******/
        // Create a new module (and put it into the cache)
        /******/
        var module = installedModules[moduleId] = {
            /******/
            exports: {},
            /******/
            id: moduleId,
            /******/
            loaded: !1
        };
        /******/
        /******/
        // Return the exports of the module
        /******/
        /******/
        /******/
        // Execute the module function
        /******/
        /******/
        /******/
        // Flag the module as loaded
        /******/
        return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), 
        module.loaded = !0, module.exports;
    }
    // webpackBootstrap
    /******/
    // The module cache
    /******/
    var installedModules = {};
    /******/
    /******/
    // Load entry module and return exports
    /******/
    /******/
    /******/
    /******/
    // expose the modules object (__webpack_modules__)
    /******/
    /******/
    /******/
    // expose the module cache
    /******/
    /******/
    /******/
    // __webpack_public_path__
    /******/
    return __webpack_require__.m = modules, __webpack_require__.c = installedModules, 
    __webpack_require__.p = "", __webpack_require__(0);
}([ /* 0 */
/***/
function(module, exports, __webpack_require__) {
    module.exports = __webpack_require__(3);
}, /* 1 */
, /* 2 */
, /* 3 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.StatelessTabs = void 0;
    var _extends2 = __webpack_require__(4), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(5), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(6), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(7), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(8), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(9), _inherits3 = _interopRequireDefault(_inherits2), _propTypes = __webpack_require__(10), _propTypes2 = _interopRequireDefault(_propTypes), _react = __webpack_require__(11), _react2 = _interopRequireDefault(_react);
    __webpack_require__(12);
    var _Tabs = __webpack_require__(16), _Tabs2 = _interopRequireDefault(_Tabs);
    exports.StatelessTabs = _Tabs2.default;
    var Tabs = function(_PureComponent) {
        function Tabs(props) {
            (0, _classCallCheck3.default)(this, Tabs);
            // Set the selected tab to the first tab with defaultSelected provided
            var _this = (0, _possibleConstructorReturn3.default)(this, (Tabs.__proto__ || (0, 
            _getPrototypeOf2.default)(Tabs)).call(this, props));
            _this.getTabs = function() {
                return _this.props.tabs.map(function(tab, index) {
                    return (0, _extends3.default)({}, tab, {
                        isSelected: index === _this.state.selectedTab,
                        onKeyboardNav: _this.tabKeyboardNavHandler,
                        onSelect: function() {
                            return _this.tabSelectHandler(index);
                        }
                    });
                });
            }, _this.tabSelectHandler = function(selectedTabIndex) {
                _this.props.onSelect(selectedTabIndex), _this.setState({
                    selectedTab: selectedTabIndex
                });
            }, _this.tabKeyboardNavHandler = function(key) {
                // Handle left and right arrow key presses by selecting the previous or next tab
                var selectedIndex = _this.state.selectedTab;
                if (null !== selectedIndex) {
                    var nextIndex = selectedIndex;
                    "ArrowLeft" === key ? nextIndex = selectedIndex - 1 < 0 ? 0 : selectedIndex - 1 : "ArrowRight" === key && (nextIndex = selectedIndex + 1 > _this.props.tabs.length - 1 ? _this.props.tabs.length - 1 : selectedIndex + 1), 
                    nextIndex !== selectedIndex && _this.tabSelectHandler(nextIndex);
                }
            };
            var defaultSelectedIndex = null;
            if (props) for (var i = 0; i < props.tabs.length; i++) if (props.tabs[i].defaultSelected) {
                defaultSelectedIndex = i;
                break;
            }
            return _this.state = {
                selectedTab: defaultSelectedIndex
            }, _this;
        }
        return (0, _inherits3.default)(Tabs, _PureComponent), (0, _createClass3.default)(Tabs, [ {
            key: "render",
            value: function() {
                return _react2.default.createElement(_Tabs2.default, {
                    onKeyboardNav: this.tabKeyboardNavHandler,
                    tabs: this.getTabs()
                });
            }
        } ]), Tabs;
    }(_react.PureComponent);
    Tabs.propTypes = {
        /** Handler for selecting a new tab. Called with the number of the tab, zero-indexed */
        onSelect: _propTypes2.default.func,
        /** The tabs to display, with content being hidden unless the tab is selected. */
        tabs: _propTypes2.default.arrayOf(_propTypes2.default.shape({
            content: _propTypes2.default.node,
            defaultSelected: _propTypes2.default.bool,
            label: _propTypes2.default.node.isRequired
        }))
    }, Tabs.defaultProps = {
        onSelect: function() {},
        tabs: []
    }, exports.default = Tabs;
}, /* 4 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/extends");
}, /* 5 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/core-js/object/get-prototype-of");
}, /* 6 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/classCallCheck");
}, /* 7 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/createClass");
}, /* 8 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/possibleConstructorReturn");
}, /* 9 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/inherits");
}, /* 10 */
/***/
function(module, exports) {
    module.exports = require("prop-types");
}, /* 11 */
/***/
function(module, exports) {
    module.exports = require("react");
}, /* 12 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(13);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(15)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 13 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(14)(), // imports
    // module
    exports.push([ module.id, "._11K76Tf-DfrCxLwyYHkdSa{display:-webkit-box;display:flex;flex-basis:100%;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;-webkit-box-flex:1;flex-grow:1;min-height:0;max-width:100%}._1tYsay-In3KB9c96Ee_rwL{display:-webkit-box;display:flex;font-weight:500;list-style-type:none;margin:0;padding:0;position:relative}._2zEM34RCz4E5ANnRakv7bM,._3iDvSMh7vCyrPjDutIR2JR{color:#42526e;cursor:pointer;font-size:14px;line-height:25px;margin:0;padding:5px 10px;white-space:nowrap}._2zEM34RCz4E5ANnRakv7bM:active,._2zEM34RCz4E5ANnRakv7bM:active:before,._2zEM34RCz4E5ANnRakv7bM:hover,._3iDvSMh7vCyrPjDutIR2JR:active,._3iDvSMh7vCyrPjDutIR2JR:active:before,._3iDvSMh7vCyrPjDutIR2JR:hover{color:#0049b0}._2zEM34RCz4E5ANnRakv7bM:focus,._3iDvSMh7vCyrPjDutIR2JR:focus{border-radius:3px;box-shadow:inset 0 0 0 2px #4c9aff;outline:none}._2zEM34RCz4E5ANnRakv7bM._11PGboIVWsWS8N_OArsReZ,._3iDvSMh7vCyrPjDutIR2JR._11PGboIVWsWS8N_OArsReZ{opacity:0;pointer-events:none;position:absolute}._2zEM34RCz4E5ANnRakv7bM{position:relative}._2zEM34RCz4E5ANnRakv7bM._3Sw5e0VDrj9W3ImWzvmA7u{flex-shrink:1;min-width:30px;overflow:hidden;text-overflow:ellipsis}._3iDvSMh7vCyrPjDutIR2JR ._35K-YN_Ze_I6WddzH8HQSe{-webkit-box-align:center;align-items:center;cursor:pointer;display:-webkit-box;display:flex}._1tYsay-In3KB9c96Ee_rwL:not(:empty):before,._2GU7xr5FxFUzKXsPYruCbs:after{background-color:#ebecf0;bottom:0;border-radius:2px;content:'';height:2px;left:10px;margin:0;position:absolute;right:10px;width:inherit}._2GU7xr5FxFUzKXsPYruCbs{color:#0052cc}._2GU7xr5FxFUzKXsPYruCbs:after{background-color:currentColor}._2zHfTcAQmwISOo3hQsxYar{display:none}.XlIi9fnj1LtJyGWfOOjil{display:-webkit-box;display:flex;padding-left:10px;-webkit-box-flex:1;flex-grow:1;min-height:0}.XlIi9fnj1LtJyGWfOOjil:not(.zyTQ8lRCdBXHgLvChsYSy){display:none}", "" ]), 
    // exports
    exports.locals = {
        "ak-tabs-root": "_11K76Tf-DfrCxLwyYHkdSa",
        akTabsRoot: "_11K76Tf-DfrCxLwyYHkdSa",
        "ak-tab-labels": "_1tYsay-In3KB9c96Ee_rwL",
        akTabLabels: "_1tYsay-In3KB9c96Ee_rwL",
        "ak-tab-label": "_2zEM34RCz4E5ANnRakv7bM",
        akTabLabel: "_2zEM34RCz4E5ANnRakv7bM",
        "ak-tabs-button-container": "_3iDvSMh7vCyrPjDutIR2JR",
        akTabsButtonContainer: "_3iDvSMh7vCyrPjDutIR2JR",
        "ak-tab-label-hidden": "_11PGboIVWsWS8N_OArsReZ",
        akTabLabelHidden: "_11PGboIVWsWS8N_OArsReZ",
        "ak-tab-label-single": "_3Sw5e0VDrj9W3ImWzvmA7u",
        akTabLabelSingle: "_3Sw5e0VDrj9W3ImWzvmA7u",
        "ak-tabs-button": "_35K-YN_Ze_I6WddzH8HQSe",
        akTabsButton: "_35K-YN_Ze_I6WddzH8HQSe",
        "ak-tab-label-selected": "_2GU7xr5FxFUzKXsPYruCbs",
        akTabLabelSelected: "_2GU7xr5FxFUzKXsPYruCbs",
        "ak-tab-dd-item-hidden": "_2zHfTcAQmwISOo3hQsxYar",
        akTabDdItemHidden: "_2zHfTcAQmwISOo3hQsxYar",
        "ak-tab-pane": "XlIi9fnj1LtJyGWfOOjil",
        akTabPane: "XlIi9fnj1LtJyGWfOOjil",
        selected: "zyTQ8lRCdBXHgLvChsYSy",
        selected: "zyTQ8lRCdBXHgLvChsYSy"
    };
}, /* 14 */
/***/
function(module, exports) {
    /*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
    // css base code, injected by the css-loader
    module.exports = function() {
        var list = [];
        // return the list of modules as css string
        // import a list of modules into the list
        return list.toString = function() {
            for (var result = [], i = 0; i < this.length; i++) {
                var item = this[i];
                item[2] ? result.push("@media " + item[2] + "{" + item[1] + "}") : result.push(item[1]);
            }
            return result.join("");
        }, list.i = function(modules, mediaQuery) {
            "string" == typeof modules && (modules = [ [ null, modules, "" ] ]);
            for (var alreadyImportedModules = {}, i = 0; i < this.length; i++) {
                var id = this[i][0];
                "number" == typeof id && (alreadyImportedModules[id] = !0);
            }
            for (i = 0; i < modules.length; i++) {
                var item = modules[i];
                // skip already imported module
                // this implementation is not 100% perfect for weird media query combinations
                //  when a module is imported multiple times with different media queries.
                //  I hope this will never occur (Hey this way we have smaller bundles)
                "number" == typeof item[0] && alreadyImportedModules[item[0]] || (mediaQuery && !item[2] ? item[2] = mediaQuery : mediaQuery && (item[2] = "(" + item[2] + ") and (" + mediaQuery + ")"), 
                list.push(item));
            }
        }, list;
    };
}, /* 15 */
/***/
function(module, exports, __webpack_require__) {
    function addStylesToDom(styles, options) {
        for (var i = 0; i < styles.length; i++) {
            var item = styles[i], domStyle = stylesInDom[item.id];
            if (domStyle) {
                domStyle.refs++;
                for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j](item.parts[j]);
                for (;j < item.parts.length; j++) domStyle.parts.push(addStyle(item.parts[j], options));
            } else {
                for (var parts = [], j = 0; j < item.parts.length; j++) parts.push(addStyle(item.parts[j], options));
                stylesInDom[item.id] = {
                    id: item.id,
                    refs: 1,
                    parts: parts
                };
            }
        }
    }
    function listToStyles(list) {
        for (var styles = [], newStyles = {}, i = 0; i < list.length; i++) {
            var item = list[i], id = item[0], css = item[1], media = item[2], sourceMap = item[3], part = {
                css: css,
                media: media,
                sourceMap: sourceMap
            };
            newStyles[id] ? newStyles[id].parts.push(part) : styles.push(newStyles[id] = {
                id: id,
                parts: [ part ]
            });
        }
        return styles;
    }
    function insertStyleElement(options, styleElement) {
        var head = getHeadElement(), lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
        if ("top" === options.insertAt) lastStyleElementInsertedAtTop ? lastStyleElementInsertedAtTop.nextSibling ? head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling) : head.appendChild(styleElement) : head.insertBefore(styleElement, head.firstChild), 
        styleElementsInsertedAtTop.push(styleElement); else {
            if ("bottom" !== options.insertAt) throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
            head.appendChild(styleElement);
        }
    }
    function removeStyleElement(styleElement) {
        styleElement.parentNode.removeChild(styleElement);
        var idx = styleElementsInsertedAtTop.indexOf(styleElement);
        idx >= 0 && styleElementsInsertedAtTop.splice(idx, 1);
    }
    function createStyleElement(options) {
        var styleElement = document.createElement("style");
        return styleElement.type = "text/css", insertStyleElement(options, styleElement), 
        styleElement;
    }
    function createLinkElement(options) {
        var linkElement = document.createElement("link");
        return linkElement.rel = "stylesheet", insertStyleElement(options, linkElement), 
        linkElement;
    }
    function addStyle(obj, options) {
        var styleElement, update, remove;
        if (options.singleton) {
            var styleIndex = singletonCounter++;
            styleElement = singletonElement || (singletonElement = createStyleElement(options)), 
            update = applyToSingletonTag.bind(null, styleElement, styleIndex, !1), remove = applyToSingletonTag.bind(null, styleElement, styleIndex, !0);
        } else obj.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (styleElement = createLinkElement(options), 
        update = updateLink.bind(null, styleElement), remove = function() {
            removeStyleElement(styleElement), styleElement.href && URL.revokeObjectURL(styleElement.href);
        }) : (styleElement = createStyleElement(options), update = applyToTag.bind(null, styleElement), 
        remove = function() {
            removeStyleElement(styleElement);
        });
        return update(obj), function(newObj) {
            if (newObj) {
                if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) return;
                update(obj = newObj);
            } else remove();
        };
    }
    function applyToSingletonTag(styleElement, index, remove, obj) {
        var css = remove ? "" : obj.css;
        if (styleElement.styleSheet) styleElement.styleSheet.cssText = replaceText(index, css); else {
            var cssNode = document.createTextNode(css), childNodes = styleElement.childNodes;
            childNodes[index] && styleElement.removeChild(childNodes[index]), childNodes.length ? styleElement.insertBefore(cssNode, childNodes[index]) : styleElement.appendChild(cssNode);
        }
    }
    function applyToTag(styleElement, obj) {
        var css = obj.css, media = obj.media;
        if (media && styleElement.setAttribute("media", media), styleElement.styleSheet) styleElement.styleSheet.cssText = css; else {
            for (;styleElement.firstChild; ) styleElement.removeChild(styleElement.firstChild);
            styleElement.appendChild(document.createTextNode(css));
        }
    }
    function updateLink(linkElement, obj) {
        var css = obj.css, sourceMap = obj.sourceMap;
        sourceMap && (// http://stackoverflow.com/a/26603875
        css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */");
        var blob = new Blob([ css ], {
            type: "text/css"
        }), oldSrc = linkElement.href;
        linkElement.href = URL.createObjectURL(blob), oldSrc && URL.revokeObjectURL(oldSrc);
    }
    /*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
    var stylesInDom = {}, memoize = function(fn) {
        var memo;
        return function() {
            return "undefined" == typeof memo && (memo = fn.apply(this, arguments)), memo;
        };
    }, isOldIE = memoize(function() {
        return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
    }), getHeadElement = memoize(function() {
        return document.head || document.getElementsByTagName("head")[0];
    }), singletonElement = null, singletonCounter = 0, styleElementsInsertedAtTop = [];
    module.exports = function(list, options) {
        options = options || {}, // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
        // tags it will allow on a page
        "undefined" == typeof options.singleton && (options.singleton = isOldIE()), // By default, add <style> tags to the bottom of <head>.
        "undefined" == typeof options.insertAt && (options.insertAt = "bottom");
        var styles = listToStyles(list);
        return addStylesToDom(styles, options), function(newList) {
            for (var mayRemove = [], i = 0; i < styles.length; i++) {
                var item = styles[i], domStyle = stylesInDom[item.id];
                domStyle.refs--, mayRemove.push(domStyle);
            }
            if (newList) {
                var newStyles = listToStyles(newList);
                addStylesToDom(newStyles, options);
            }
            for (var i = 0; i < mayRemove.length; i++) {
                var domStyle = mayRemove[i];
                if (0 === domStyle.refs) {
                    for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();
                    delete stylesInDom[domStyle.id];
                }
            }
        };
    };
    var replaceText = function() {
        var textStore = [];
        return function(index, replacement) {
            return textStore[index] = replacement, textStore.filter(Boolean).join("\n");
        };
    }();
}, /* 16 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _getPrototypeOf = __webpack_require__(5), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(6), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(7), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(8), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(9), _inherits3 = _interopRequireDefault(_inherits2), _propTypes = __webpack_require__(10), _propTypes2 = _interopRequireDefault(_propTypes), _react = __webpack_require__(11), _react2 = _interopRequireDefault(_react), _styles = __webpack_require__(12), _styles2 = _interopRequireDefault(_styles), _TabPane = __webpack_require__(17), _TabPane2 = _interopRequireDefault(_TabPane), _TabsNav = __webpack_require__(20), _TabsNav2 = _interopRequireDefault(_TabsNav), Tabs = function(_PureComponent) {
        function Tabs() {
            return (0, _classCallCheck3.default)(this, Tabs), (0, _possibleConstructorReturn3.default)(this, (Tabs.__proto__ || (0, 
            _getPrototypeOf2.default)(Tabs)).apply(this, arguments));
        }
        return (0, _inherits3.default)(Tabs, _PureComponent), (0, _createClass3.default)(Tabs, [ {
            key: "render",
            value: function() {
                var selectedTabs = this.props.tabs.filter(function(tab) {
                    return tab.isSelected;
                }), selectedTab = selectedTabs.length ? _react2.default.createElement(_TabPane2.default, {
                    isSelected: selectedTabs[0].isSelected
                }, selectedTabs[0].content) : null;
                return _react2.default.createElement("div", {
                    className: _styles2.default.akTabsRoot
                }, _react2.default.createElement(_TabsNav2.default, {
                    onKeyboardNav: this.props.onKeyboardNav,
                    tabs: this.props.tabs
                }), selectedTab);
            }
        } ]), Tabs;
    }(_react.PureComponent);
    Tabs.propTypes = {
        /** Handler for navigation using the keyboard buttons. */
        onKeyboardNav: _propTypes2.default.func.isRequired,
        /** The tabs to display, with content being hidden unless the tab is selected. */
        tabs: _propTypes2.default.arrayOf(_propTypes2.default.shape({
            content: _propTypes2.default.node,
            isSelected: _propTypes2.default.bool,
            label: _propTypes2.default.node.isRequired,
            onSelect: _propTypes2.default.func.isRequired
        }))
    }, Tabs.defaultProps = {
        tabs: []
    }, exports.default = Tabs;
}, /* 17 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _defineProperty2 = __webpack_require__(18), _defineProperty3 = _interopRequireDefault(_defineProperty2), _getPrototypeOf = __webpack_require__(5), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(6), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(7), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(8), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(9), _inherits3 = _interopRequireDefault(_inherits2), _propTypes = __webpack_require__(10), _propTypes2 = _interopRequireDefault(_propTypes), _react = __webpack_require__(11), _react2 = _interopRequireDefault(_react), _classnames = __webpack_require__(19), _classnames2 = _interopRequireDefault(_classnames), _styles = __webpack_require__(12), _styles2 = _interopRequireDefault(_styles), TabPane = function(_PureComponent) {
        function TabPane() {
            return (0, _classCallCheck3.default)(this, TabPane), (0, _possibleConstructorReturn3.default)(this, (TabPane.__proto__ || (0, 
            _getPrototypeOf2.default)(TabPane)).apply(this, arguments));
        }
        return (0, _inherits3.default)(TabPane, _PureComponent), (0, _createClass3.default)(TabPane, [ {
            key: "render",
            value: function() {
                return _react2.default.createElement("div", {
                    "aria-hidden": this.props.isSelected ? "false" : "true",
                    className: (0, _classnames2.default)(_styles2.default.akTabPane, (0, _defineProperty3.default)({}, _styles2.default.selected, this.props.isSelected)),
                    role: "tabpanel"
                }, this.props.children);
            }
        } ]), TabPane;
    }(_react.PureComponent);
    TabPane.propTypes = {
        children: _propTypes2.default.node,
        isSelected: _propTypes2.default.bool
    }, TabPane.defaultProps = {
        isSelected: !1
    }, exports.default = TabPane;
}, /* 18 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/defineProperty");
}, /* 19 */
/***/
function(module, exports) {
    module.exports = require("classnames");
}, /* 20 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _defineProperty2 = __webpack_require__(18), _defineProperty3 = _interopRequireDefault(_defineProperty2), _getPrototypeOf = __webpack_require__(5), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(6), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(7), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(8), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(9), _inherits3 = _interopRequireDefault(_inherits2), _propTypes = __webpack_require__(10), _propTypes2 = _interopRequireDefault(_propTypes), _react = __webpack_require__(11), _react2 = _interopRequireDefault(_react), _classnames = __webpack_require__(19), _classnames2 = _interopRequireDefault(_classnames), _styles = __webpack_require__(12), _styles2 = _interopRequireDefault(_styles), TabsNav = function(_PureComponent) {
        function TabsNav() {
            var _ref, _temp, _this, _ret;
            (0, _classCallCheck3.default)(this, TabsNav);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
            return _temp = _this = (0, _possibleConstructorReturn3.default)(this, (_ref = TabsNav.__proto__ || (0, 
            _getPrototypeOf2.default)(TabsNav)).call.apply(_ref, [ this ].concat(args))), _this.state = {
                wasKeyboardNav: !1
            }, _this.tabKeyDownHandler = function(e) {
                _this.setState({
                    wasKeyboardNav: !0
                }), _this.props.onKeyboardNav(e.key);
            }, _this.tabMouseDownHandler = function(e) {
                return e.preventDefault();
            }, _ret = _temp, (0, _possibleConstructorReturn3.default)(_this, _ret);
        }
        return (0, _inherits3.default)(TabsNav, _PureComponent), (0, _createClass3.default)(TabsNav, [ {
            key: "shouldComponentUpdate",
            value: function(nextProps, nextState) {
                // Don't re-render when we are resetting the `wasKeyboardNav` state
                return !(nextState.wasKeyboardNav !== this.state.wasKeyboardNav && !nextState.wasKeyboardNav);
            }
        }, {
            key: "componentDidUpdate",
            value: function() {
                var _this2 = this;
                // Focus the selected tab if it was selected via keyboard nav
                this.tabs.forEach(function(tab) {
                    tab.el && (_this2.state.wasKeyboardNav && tab.isSelected ? (tab.el.focus(), _this2.setState({
                        wasKeyboardNav: !1
                    })) : // Ensure that focus does not stay on an unselected tab
                    tab.el.blur());
                });
            }
        }, {
            key: "render",
            value: function() {
                var _this3 = this;
                /* eslint-disable jsx-a11y/role-supports-aria-props, jsx-a11y/no-static-element-interactions */
                return this.tabs = [], _react2.default.createElement("div", null, _react2.default.createElement("ul", {
                    className: _styles2.default.akTabLabels,
                    role: "tablist"
                }, this.props.tabs.map(function(tab, index) {
                    return _react2.default.createElement("li", {
                        "aria-posinset": index + 1,
                        "aria-selected": tab.isSelected,
                        "aria-setsize": _this3.props.tabs.length,
                        className: (0, _classnames2.default)(_styles2.default.akTabLabel, (0, _defineProperty3.default)({}, _styles2.default.akTabLabelSelected, tab.isSelected)),
                        key: index,
                        onClick: tab.onSelect,
                        onKeyDown: _this3.tabKeyDownHandler,
                        onMouseDown: _this3.tabMouseDownHandler,
                        ref: function(_ref2) {
                            _this3.tabs.push({
                                el: _ref2,
                                isSelected: tab.isSelected
                            });
                        },
                        role: "tab",
                        tabIndex: tab.isSelected ? 0 : -1
                    }, tab.label);
                })));
            }
        } ]), TabsNav;
    }(_react.PureComponent);
    TabsNav.propTypes = {
        onKeyboardNav: _propTypes2.default.func.isRequired,
        tabs: _propTypes2.default.arrayOf(_propTypes2.default.shape({
            content: _propTypes2.default.node,
            label: _propTypes2.default.string.isRequired,
            onSelect: _propTypes2.default.func.isRequired,
            isSelected: _propTypes2.default.bool
        }))
    }, TabsNav.defaultProps = {
        tabs: []
    }, exports.default = TabsNav;
} ]);


//////////////////
// WEBPACK FOOTER
// ../tabs/dist/bundle-cjs.js
// module id = 524
// module chunks = 0